/*
 * Module for the the content page, which shows an individual piece of web content
 */

define([
  "marionette",
  "messaging/messenger",
  "modules/contentsSplit/content/contentModification/contentModificationView",
], function (Marionette, Messenger, ContentModificationView) {
  var ContentController = Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "contentModification";
      this.region = options.region;
      this._setUpVents();
    },
    show: function (contentUrlModel) {
      this.contentUrlModel = contentUrlModel;

      this.view = new ContentModificationView.contentModificationView({
        model: this.contentUrlModel,
      });
      this.view.on(
        "approve:modifications",
        function () {
          this.contentUrlModel.set("isModified", false);
          this.contentUrlModel.set("isApproved", true);
          this.view.render();
        },
        this,
      );
      this.view.on(
        "ignore:modifications",
        function () {
          this.contentUrlModel.set("isModified", false);
          this.contentUrlModel.set("isIgnored", true);
          this.view.render();
        },
        this,
      );
      this.view.on(
        "stop:ignoring:modifications",
        function () {
          this.contentUrlModel.set("isModified", false);
          this.contentUrlModel.set("isApproved", false);
          this.contentUrlModel.set("isIgnored", false);
          this.view.render();
        },
        this,
      );
      this.showRegion(this.view);
    },
    _setUpVents: function () {
      //an event to pass the current content url model to this module and rerender it
      Messenger.vent.on(
        "show:modification:information",
        function (contentUrlModel) {
          this.show(contentUrlModel);
        },
        this,
      );
    },
  });

  return ContentController;
});
